<template>
  <div>
    <v-edit-dialog
        v-if="!readonly"
        @save="onSave()"
        @open="deleted = true"
        :save-text="$t('are_you_sure')"
        :cancel-text="$t('cancel')"
        large
        :disabled="readonly"
    >
      <v-row
        v-if="!readonly"
        no-gutters
        class="flex-nowrap my-4"
      >
        <v-icon :small="small" color="red darken-4">mdi-delete-forever-outline</v-icon>
        <span v-if="show_label" class="ml-2 text-body-1">{{ $t('purge') }}</span>
      </v-row>
      <template v-slot:input>
        <v-sheet class="mt-5">
          <span>{{ $t('purge_message') }}</span>
        </v-sheet>
      </template>
    </v-edit-dialog>
    <v-row
        v-if="readonly"
        no-gutters
        class="flex-nowrap my-4"
      >
      <v-icon disabled color="red darken-4">mdi-delete-restore</v-icon>
      <span v-if="show_label" disabled class="ml-2 text-body-1">{{ $t('purge') }}</span>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'BaseDeleteIcon',
  props: {
    readonly: {type: [Boolean], default: false},
    show_label: {type: [Boolean], default: false},
    small: {type: [Boolean], default: false},
  },

  components: {},

  computed: {},

  methods: {
    onSave() {
      // console.log('onSave', this.deleted)
      this.$emit('input', !this.deleted)
      this.$emit('confirm')
    },

  },

  async mounted() {
    // this.deleted = this.value
  },

  data() {
    return {
      deleted: null,
      confirmDialog: false,
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n>
{
  "en": {
    "are_you_sure": "Are you sure?",
    "cancel": "Cancel",
    "purge_message": "Purge",
    "delete": "Delete",
    "delete_message": "Do you want to delete? Are you sure?",
    "restore_message": "Do you want to restore? Are you sure?"
  },
  "de": {
    "are_you_sure": "Bist du sicher?",
    "cancel": "Stornieren",
    "purge_message": "Purge",
    "delete": "löschen",
    "delete_message": "Möchten Sie löschen? Bist du dir sicher?",
    "restore_message": "Möchten Sie wiederherstellen? Bist du dir sicher?"
  }
}
</i18n>
